<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'app',
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style src="bootstrap-datepicker/dist/css/bootstrap-datepicker.css"></style>

<style lang="scss">
  @media all {
    .page-break {
      display: none;
    }
  }

  @media print {
    .page-break {
      display: block;
      page-break-before: always;
    }
  }

  /*//.row .dataTable {
  //  margin: 0px 15px 0px 15px;
  //}*/
  .item-view {
    list-style: none;
    padding: 0px 15px 0px 15px;
  }

    .item-view li:not(:last-child) {
      border-bottom: 1px solid rgba(0,0,0,.525);
    }

    .item-view li:not(:first-child) {
      padding: 15px 0px 0px 0px;
    }

  .not-prod {
    color: black;
    padding: 5px;
    position: absolute;
    width: 400px;
    left: 50%;
    margin-left: -200px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }

  .buttons-excel {
    margin-right: 10px;
  }

  .dt-buttons {
    float: left;
    margin-right: 10px;
  }

  #dataTable {
    display: none
  }

  $blue : #007bff;
  $green: #41b883;

  .pace {
    z-index: 9999;
  }

  .badge-default {
    background-color: #343a40;
  }

  .hidden {
    display: none;
  }

  .dataTables_wrapper {
    padding: 0px;
  }

  table.dataTable thead .sorting.no-sort {
    cursor: default;
  }

    table.dataTable thead .sorting.no-sort::before,
    table.dataTable thead .sorting.no-sort::after {
      content: "";
    }

  .custom-control-input:disabled ~ .custom-control-indicator {
    background-color: gray !important;
  }

  /*
  input:disabled, textarea:disabled, select:disabled {
  border: 0px;
  background: none !important;
  }*/

  .multiselect__option--highlight[data-select="+"] {
    background-color: $green;
  }

  .multiselect__option--highlight,
  .multiselect__tag {
    background-color: $blue;
  }

  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background-color: $blue;
  }

  /** time Picker **/
  .glyphicon {
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: 'FontAwesome';
    font-style: normal;
    font-weight: normal;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .glyphicon-time:before {
    content: "\f017";
  }

  .glyphicon-chevron-left:before {
    content: "\f053";
  }

  .glyphicon-chevron-right:before {
    content: "\f054";
  }

  .glyphicon-chevron-up:before {
    content: "\f077";
  }

  .glyphicon-chevron-down:before {
    content: "\f078";
  }

  .glyphicon-calendar:before {
    content: "\f073";
  }

  .glyphicon-screenshot:before {
    content: "\f185";
  }

  .btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
  }

  .collapse {
    display: none;
  }

    .collapse.in {
      display: block;
    }

  .dropdown-menu {
    position: absolute;
    left: 0;
    z-index: 1000;
    display: none;
    float: left;
    min-width: 160px;
    padding: 5px 0;
    margin: 2px 0 0;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-color: #fff;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, .15);
    border-radius: 4px;
    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
  }

  .list-unstyled {
    padding-left: 0;
    list-style: none;
  }

  /* Table */

  .clickable-row:hover,
  .clickable-row:active,
  .clickable-row:focus {
    cursor: pointer;
    td

  {
    background-color: #e9ecef;
  }

  }

  ul.legend {
    list-style: none;
    padding: 0px;
  }

    ul.legend li {
      padding: 5px;
      width: 350px;
      float: left;
    }

  .clickable-row .companyStatus, .legend span, .card-header .companyStatus, .totalValue {
    padding: 0px 12px 0px 0px;
    margin: 0px 5px 0px 0px;
    border: 1px solid rgba(0, 0, 0, 0.277);
  }

  .imported_alert {
    padding: 0px 3px;
    margin: 0px 2px 0px 0px;
    border: 1px solid rgba(0, 0, 0, 0.277);
    background-color: #ffc107 !important;
    font-weight: bold;
    float: right
  }

  .card-header .companyStatus {
    padding: 10px 50px;
    margin: 0px 50px 0px 0px;
    float: right;
    right: 20px;
  }

  /* Active */
  .companyStatus_1, .totalValue_true {
    background-color: rgba(2, 222, 2, 0.5);
    color: black
  }

  /* inactive */
  .companyStatus_0 {
    background-color: rgba(183, 0, 0, 0.5);
    color: black
  }

  .exitReason_0 {
    background-color: rgba(230, 230, 230, 0.715);
    color: black
  }
  /* Publique IPO */
  .exitReason_1 {
    background-color: rgba(0, 183, 119, 0.715);
    color: black
  }
  /* Vendue */
  .exitReason_2 {
    background-color: rgba(0, 119, 183, 0.5);
    color: black
  }
  /* Faillite */
  .exitReason_3 {
    background-color: rgba(183, 0, 0, 0.5);
    color: black
  }
  /* Fermee */
  .exitReason_4, .totalValue_false {
    background-color: rgba(220, 59, 0, 0.708);
    color: black
  }
  /* Non-operante */
  .exitReason_5 {
    background-color: rgba(84, 84, 84, 0.5);
    color: black
  }
  /* Vente d'actions totale */
  .exitReason_6 {
    background-color: rgba(183, 162, 0, 0.5);
    color: black
  }
  /* Vente d'actions partielle */
  .exitReason_7 {
    background-color: rgba(234, 255, 0, 0.722);
    color: black
  }

  .input-group-addon {
    padding: .375rem .75rem;
    margin-bottom: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    text-align: center;
    background-color: #e9ecef;
    border: 1px solid #ced4da;
    border-radius: .25rem;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue